import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class UserAPI {
  createUser(userReq) {
    return api.post(API_URLS.URL.createUser, userReq);
  }

  getUser() {
    return api.get(API_URLS.URL.getUser);
  }

  updateUser(userId, userReq) {
    const updateUser = API_URLS.URL.updateUser.replace(":user_id", userId);
    return api.put(updateUser, userReq);
  }

  changePassword(userReq) {
    return api.post(API_URLS.URL.changePassword, userReq);
  }

  getUserList(userReq) {
    return api.post(API_URLS.URL.getUserList, userReq);
  }

  uploadPhoto(userReq) {
    return api.post(API_URLS.URL.uploadUserProfile, userReq);
  }
  
  getQuicksightEmbedUrl() {
    return api.get(API_URLS.URL.Quicksight.getQuicksightEmbedUrl);
  }
}
